export default __webpack_public_path__ + "static/media/StretchNStrengthen.e7c1b48b.png";